import { Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, FormControlLabel, Grid, InputLabel, MenuItem, Select, Switch, TextField } from '@mui/material';
import React, { useEffect, useState } from 'react'
import { FetchBranchShowData, FetchSpecializationShowData, LocationShowdata, SemesterAdd, SemesterUpdate } from '../../../services/LoginPageService';

const SemesterModel = ({open, setOpen, isAddButton, editSemester,setRefreshData,setNotification}) => {
    const [location,setLocation]=useState('');
    const [locationList,setLocationList]=useState([]);
    const [LocDisabled,setLocDisabled] = useState(false);
    const[branch,setBranch]=useState('');
    const[branchList,setBranchList]=useState([]);
    const [branchDisabled,setBranchDisabled]= useState(false);
    const[specialization,setSpecialization]=useState('');
    const[specializationList,setSpecializationList]=useState([]);
    const[semester,setSemester]=useState('');
    const[description,setDescription]=useState('');
    const[smsDisabled,setSmsDisabled]=useState(false);
   
    const handleClose = () => {
        setOpen(false);
        clearForm();
    };

    useEffect(()=>{
        console.log("dataa",editSemester?.specializationsId )
        LocationShowdata(handleLocationshow,handleLocationshowException);
        setBranch(editSemester?.branchId || '');
        setSpecialization(editSemester?.specializationsId || '');
        setSemester(editSemester?.semester || '');
        setDescription(editSemester?.description || '');
        setSmsDisabled(editSemester?.sms_disabled == 1 ? true : false);
        setLocation(editSemester?.locationId || '');
        if(editSemester)
        {
            SelectionDisabled();
        }
    },[editSemester])

    const SelectionDisabled = ()=>{
        setLocDisabled(true);
        setBranchDisabled(true);
    }

    const handleLocationshow=(dataObject)=>{
        setLocationList(dataObject?.data);
        console.log(dataObject?.data);
        if(editSemester?.locationId)
        {
            FetchBranchShowData({id:editSemester?.locationId},handleBranchSuccess, handleBranchException);
        }
    }

    const handleLocationshowException=(error,errorMessage)=>{
        console.log(errorMessage);
    }

    const handleBranchSuccess = (dataObject) =>{
        console.log('data Branch');
        setBranchList(dataObject.data);
        if(editSemester?.branchId)
        {
            FetchSpecializationShowData({id:editSemester?.branchId},handleSpecializationSuccess, handleSpecializationException);
        }
    }
      
    const handleBranchException= (errorStaus, errorMessage) =>{
        console.log(errorMessage);
    }

    const onLocationChange=(e)=>{
        setLocation(e.target.value);
        FetchBranchShowData({id:e.target.value},handleBranchSuccess, handleBranchException);
    }

    const onBranchChange=(e)=>{
        setBranch(e.target.value);
        FetchSpecializationShowData({id:e.target.value},handleSpecializationSuccess, handleSpecializationException);
    }

    const handleSpecializationSuccess = (dataObject) =>{
        console.log('data Branch');
        setSpecializationList(dataObject.data);
    }

    const onSpecializationChange=(e)=>{
        setSpecialization(e.target.value);
    }

    const handleSpecializationException= (errorStaus, errorMessage) =>{
        console.log(errorMessage);
    }

    const onSubmit = (e) => {
        e.preventDefault();
        isAddButton === true ?
        (
            SemesterAdd({
                id:location,
                location:location,
                branch:branch,
                specialization:specialization,
                semester:semester,
                description:description,
                sms_disabled: smsDisabled ? 1 : 0,
            }, handleAddSuccess, handleException)
        ) : (
            SemesterUpdate({
                id: editSemester.id,
                location:location,
                branch:branch,
                specialization:specialization,
                semester:semester,
                description:description,
                sms_disabled: smsDisabled ? 1 : 0,
          }, handleUpdateSuccess, handleException)
        );
    }

    const handleAddSuccess = (dataObject) => {
        console.log(dataObject); 
        setNotification({
          status: true,
          type: 'success',
          message: dataObject.message,
        });
        setTimeout(() => {
            setOpen(false);
        }, 2000);
        setRefreshData(oldValue => !oldValue);
        clearForm();
    }

    const clearForm = () => {
        setLocation('');
        setBranch('');
        setSpecialization('');
        setBranchList([]);
        setSpecializationList([]);
        setSemester('');
        setDescription('');
        setSmsDisabled(false);
        setLocDisabled(false);
        setBranchDisabled(false);
        setRefreshData(oldValue => !oldValue);
    }  
    
    const handleUpdateSuccess = (dataObject) => {
        console.log(dataObject);
        setNotification({
          status: true,
          type: 'success',
          message: dataObject.message,
        });
        setTimeout(() => {
            setOpen(false);
        }, 2000);
        setRefreshData(oldValue => !oldValue);
        clearForm();
    }

    const handleException = (errorObject, errorMessage) => {
        console.log(errorMessage);
        setNotification({
          status: true,
          type: 'error',
          message: errorMessage,
        });
        setLocation('');
        setBranch('');
        setSpecialization('');
        setSemester('');
        setDescription('');
        clearForm();
    }
    
    return (
        <div>
            <Dialog
            sx={{ '& .MuiDialog-paper': { width: '32%', maxHeight: '100%' } }}
            maxWidth="lg"
            open={open}>
                <form onSubmit={onSubmit}>
                    <DialogTitle style={{background:'#f7f7f7',color:'black'}}>
                        {isAddButton === true ? 'Add ' : 'Update '}Semester
                    </DialogTitle>
                    <DialogContent>
                        <Grid container spacing={2} style={{marginTop:'20px'}}>
                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                <FormControl fullWidth>
                                    <InputLabel id="demo-simple-select-label">Location</InputLabel>
                                    <Select
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    label="Location"
                                    placeholder='Location'
                                    value={location}
                                    disabled ={LocDisabled}
                                    required
                                    onChange={(e) => onLocationChange(e) }>
                                    {
                                        locationList?.map((data, index) => {
                                            return (
                                                <MenuItem value={data.id} key={index}>{data.location}</MenuItem>
                                            )
                                        })

                                    }           
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                <FormControl fullWidth>
                                    <InputLabel id="demo-simple-select-label">Hostel Name</InputLabel>
                                    <Select
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    label="Hostel Name"
                                    placeholder='Hostel Name'
                                    value={branch}
                                    disabled={branchDisabled}
                                    required
                                    onChange={(e) => onBranchChange(e) }>
                                        {
                                            branchList.length !== 0 ? (

                                            <MenuItem value="" key={0}>
                                            <em>Select Hostel Name</em>
                                            </MenuItem>
                                            )
                                        :
                                         (   <MenuItem value="" key={0}>
                                            <em>Select Location </em>
                                            </MenuItem>
                                        )}
                                      
                                    {
                                        branchList?.map((data, index) => {
                                            return (
                                                <MenuItem value={data.id} key={index}>{data.branch}</MenuItem>
                                            )
                                        })
                                    }      
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                <FormControl fullWidth>
                                    <InputLabel id="demo-simple-select-label">Specialization</InputLabel>
                                    <Select
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    label="Specialization"
                                    placeholder='Specialization'
                                    value={specialization}
                                    required
                                    onChange={(e) => onSpecializationChange(e) }>
                                        {
                                            specializationList.length !== 0 ? (

                                            <MenuItem value="" key={0}>
                                            <em>Select Specialization</em>
                                            </MenuItem>
                                            )
                                        :
                                         (   <MenuItem value="" key={0}>
                                            <em>Select Hostel Name </em>
                                            </MenuItem>
                                        )}
                                    {
                                        specializationList?.map((data, index) => {
                                            return (
                                                <MenuItem value={data.id} key={index}>{data.specialization}</MenuItem>
                                            )
                                        })
                                    }                                          
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                <TextField 
                                fullWidth 
                                label="Year"
                                placeholder='Year'
                                variant="outlined"
                                required
                                onChange={(e) => { setSemester(e.target.value) }}
                                value={semester}/>
                            </Grid>
                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                <TextField
                                    fullWidth
                                    label="Description"
                                    placeholder='Description'
                                    variant="outlined"
                                    required
                                    onChange={(e) => { setDescription(e.target.value) }}
                                    value={description}
                                />
                            </Grid>
                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                <FormControlLabel
                                    control={
                                        <Switch
                                            checked={smsDisabled}
                                            onChange={(e) => setSmsDisabled(e.target.checked)}
                                            color="error"
                                        />
                                    }
                                    label="Disable Attendance SMS"
                                />
                            </Grid>
                        </Grid>
                    </DialogContent>
                    <DialogActions>
                        <Button type='submit'>
                        {
                            isAddButton ? 'Add' : 'update'
                        }       
                        </Button>
                        <Button onClick={handleClose}>Cancel</Button>
                    </DialogActions>
                </form>
            </Dialog>
        </div>
    )
}

export default SemesterModel
